/* eslint-disable @typescript-eslint/no-explicit-any -- U2000Input* attend FormStateHandlers générique large */
import U2000InputText from '../../../u2000Core/components/formControls/input/U2000InputText';
import U2000InputMemo from '../../../u2000Core/components/formControls/input/U2000InputMemo';
import U2000CheckBox from '../../../u2000Core/components/formControls/checkbox/U2000CheckBox';
import type { TFunction } from 'i18next';
import { NS } from '../../U2201';
import type { U2000FormStateHandlers } from '../../../u2000Core/reducer/formReducer/U2000FormStateHandlers';
import type { U2201JobScheduleFormRow } from '../../U2201Service';

interface U2201JobScheduleBodyProps {
  formStateHandlers: U2000FormStateHandlers<U2201JobScheduleFormRow>;
  t: TFunction;
}

function U2201JobScheduleBody({ formStateHandlers, t }: U2201JobScheduleBodyProps) {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <U2000InputText
          formStateHandlers={formStateHandlers as any}
          fieldName="scheduleCode"
          label={t('lblScheduleCode', { ns: NS })}
          readonly={true}
        />
        <U2000InputText
          formStateHandlers={formStateHandlers as any}
          fieldName="jobType"
          label={t('lblJobType', { ns: NS })}
          readonly={true}
        />
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <U2000InputText
          formStateHandlers={formStateHandlers as any}
          fieldName="cronExpression"
          label={t('lblCronExpression', { ns: NS })}
          required
        />
        <U2000InputText
          formStateHandlers={formStateHandlers as any}
          fieldName="timezone"
          label={t('lblTimezone', { ns: NS })}
          required
        />
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="flex items-end">
          <U2000CheckBox
            formStateHandlers={formStateHandlers as any}
            fieldName="enabled"
            label={t('lblEnabled', { ns: NS })}
          />
        </div>
        <U2000InputText
          type="number"
          formStateHandlers={formStateHandlers as any}
          fieldName="maxAttempts"
          label={t('lblMaxAttempts', { ns: NS })}
          required
        />
      </div>

      <U2000InputMemo
        formStateHandlers={formStateHandlers as any}
        fieldName="payloadJson"
        label={t('lblPayload', { ns: NS })}
        rows={8}
        minHeight="10rem"
        placeholder='{"key": "value"}'
      />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <U2000InputText
          formStateHandlers={formStateHandlers as any}
          fieldName="nextRunAt"
          label={t('lblNextRunAt', { ns: NS })}
          readonly={true}
        />
        <U2000InputText
          formStateHandlers={formStateHandlers as any}
          fieldName="lastRunAt"
          label={t('lblLastRunAt', { ns: NS })}
          readonly={true}
        />
      </div>

      <U2000InputText
        formStateHandlers={formStateHandlers as any}
        fieldName="lastJobId"
        label={t('lblLastJobId', { ns: NS })}
        readonly={true}
      />
    </div>
  );
}

export default U2201JobScheduleBody;
